import { render, staticRenderFns } from "./otelara.vue?vue&type=template&id=cfa27fda&scoped=true&"
import script from "./otelara.vue?vue&type=script&lang=js&"
export * from "./otelara.vue?vue&type=script&lang=js&"
import style0 from "./otelara.vue?vue&type=style&index=0&id=cfa27fda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa27fda",
  null
  
)

export default component.exports